import script from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroSection.vue?vue&type=script&setup=true&lang=ts"

import "./HeroSection.vue?vue&type=style&index=0&id=1084696b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_typescript@5.1.6__webpack@5.99.6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1084696b"]])

export default __exports__